import { axios } from '@Root/API'

export const get = (engagementId, studentInitiativesId) => {
	return axios.get(`student-engagement/${engagementId}/student-initiative/${studentInitiativesId}`)
}
